import { useEffect, useState } from 'react';
import axios from 'axios';
import { WarningCircle } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Discrete reminder shown at the top of every Admin panel page while
   maintenance_mode is active, so a super-admin never forgets the site is
   closed to everyone else. Admin panel UI is English-only (existing
   convention across AdminPage.js) — not part of the FR/EN/MG public i18n. */
export const MaintenanceBanner = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    axios.get(`${API}/platform/maintenance-status`)
      .then((res) => setEnabled(!!res.data?.maintenance_mode))
      .catch(() => setEnabled(false));
  }, []);

  if (!enabled) return null;

  return (
    <div
      className="bg-danger text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 text-center"
      data-testid="maintenance-banner"
    >
      <WarningCircle size={16} weight="fill" className="flex-shrink-0" />
      Maintenance Mode is ON — the site is closed to everyone except admins. Turn it off in Platform Settings when you're done.
    </div>
  );
};
